import { useState } from 'react';
import { postAPI, putAPI } from '../../api';
import TextEditor from '../TextEditor';
import { Form, Field } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { useNavigate } from 'react-router-dom';
import { FormStyled } from '../Layout';
import CartelUpload from '../CartelUpload';

export default function App({ customValues, editar }) {

  const navigate = useNavigate();

  const [fileS3, setFileS3] = useState(customValues.cartel || '');
  const [subiendoCurso, setSubiendoCurso] = useState(false)
  const [error, setError] = useState('')


  // SUBMIT: cualquier error de la API se muestra junto al botón en lugar de quedar en silencio.
  const onSubmit = async values => {
    const profesor = {
      nombre: values.nombre,
      descripcion: window.localStorage.getItem('draftjs-content'),
      ...(fileS3 ? { cartel: fileS3 } : {}),
    };
    setError('');
    setSubiendoCurso(true);
    try {
      if (!editar) await postAPI('equipo', profesor);
      else await putAPI('equipo', values.idMongo, profesor);
    } catch (e) {
      setError(e.message || 'No se pudo guardar el miembro del equipo');
      setSubiendoCurso(false);
      return;
    }
    setSubiendoCurso(false);
    alert(editar ? 'Cambios guardados' : 'Miembro del equipo añadido');
    if (editar) navigate(0);
    else navigate('/equipo');
  }

  // Validation
  const required = value => (value ? undefined : ' Obligatorio')
  const composeValidators = (...validators) => value =>
    validators.reduce((error, validator) => error || validator(value), undefined)

  return (
    <FormStyled>
      <Form
        onSubmit={onSubmit}
        initialValues={customValues}
        mutators={{
          ...arrayMutators
        }}
        render={({ handleSubmit, values }) => (

          <form onSubmit={handleSubmit}>

            <div className='input-curso'>
              <h3>Foto</h3>
              <CartelUpload value={fileS3} onChange={setFileS3} />
            </div>


            <div className='input-curso'>
              <h3>Nombre</h3>
              <Field
                name="nombre"
                validate={composeValidators(required)}
              >
                {({ input, meta }) => (
                  <div>
                    <input {...input} type="text" placeholder="Nombre" />
                    {meta.error && meta.touched && <span>{meta.error}</span>}
                  </div>
                )}
              </Field>
            </div>

              <h3>Descripcion</h3>
            <div className='input-sinopsis'>
              <TextEditor editorState={customValues?.editorState} />
            </div>

            <button id="btn-submit" type="submit" disabled={subiendoCurso}>{subiendoCurso ? <span>Guardando...</span> : editar ? <span>Guardar cambios</span> : <span>Añadir  Profesor</span>}</button>
            {error && <p className="form-error" role="alert">No se pudo guardar: {error}</p>}
          </form>
        )}
      />
    </FormStyled>
  );
}